import { contestConstants } from '../_constants';

//-- get the list of Contest
export function getContestsList(state = {}, action) {
  switch (action.type) {
    case contestConstants.CONTEST_LIST_REQUEST:
      return {
        getContestsList: false
      };

    case contestConstants.CONTEST_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { isGetAdvertismentList: true, getContestsList: action.successAction };

    case contestConstants.CONTEST_LIST_ERROR:
      return {
        getContestsList: false,
      };

    case contestConstants.CONTEST_SEARCH_REQUEST:
      return { isGetAdvertismentList: true, getContestsList: action.successAction.data };

    default:
      return state
  }
}

//-- save the list of Contest
export function saveContest(state = {}, action) {
  switch (action.type) {
    case contestConstants.CONTEST_ADDED_REQUEST:
      return {
        savedContest: false
      };

    case contestConstants.CONTEST_ADDED_SUCCESS:
      //console.log("REDUCER ", action);
      return { savedContest: action.successAction };

    case contestConstants.CONTEST_ADDED_FAILURE:
      return {
        savedContest: false,
      };

    default:
      return state
  }
}

//-- delete the Contest
export function deleteContest(state = {}, action) {
  switch (action.type) {
    case contestConstants.CONTEST_DELETE_REQUEST:
      return {
        deleteContest: false
      };

    case contestConstants.CONTEST_DELETE_SUCCESS:
      //console.log("REDUCER ", action);
      return { deleteContest: action.successAction };

    case contestConstants.CONTEST_DELETE_FAILURE:
      return {
        deleteContest: false,
      };

    default:
      return state
  }
}